export default __webpack_public_path__ + "static/media/BACKGROUND_CRES_SOFT1.b4c5dc21.png";